// Små DOM-hjælpere uden framework.

type Attrs = Record<string, string | number | boolean | undefined | null | ((e: Event) => void)>;
type Child = Node | string | null | undefined | false;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === null || v === false) continue;
    if (typeof v === 'function') {
      el.addEventListener(k.replace(/^on/, '').toLowerCase(), v as EventListener);
    } else if (k === 'class') {
      el.className = String(v);
    } else if (k === 'html') {
      el.innerHTML = String(v);
    } else if (v === true) {
      el.setAttribute(k, '');
    } else {
      el.setAttribute(k, String(v));
    }
  }
  for (const c of children) {
    if (c === null || c === undefined || c === false) continue;
    el.append(c);
  }
  return el;
}

export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Mangler #${id}`);
  return el;
}

/** Sæt tekst kun når den ændrer sig (billigt at kalde hver frame). */
export function setText(el: Element, text: string): void {
  if (el.textContent !== text) el.textContent = text;
}

export function setAttr(el: Element, name: string, value: string | null): void {
  if (value === null) {
    if (el.hasAttribute(name)) el.removeAttribute(name);
  } else if (el.getAttribute(name) !== value) {
    el.setAttribute(name, value);
  }
}

export function toggle(el: Element, cls: string, on: boolean): void {
  if (el.classList.contains(cls) !== on) el.classList.toggle(cls, on);
}

/**
 * Vis en genvejstast på en knap: title, aria-keyshortcuts og et lille <kbd>-mærke, som kun ses på
 * en skærm med mus (CSS: .kbd). `keys` står på mærket, `aria` er det, skærmlæseren får.
 */
export function kbd(el: HTMLElement, keys: string, aria: string = keys, title?: string): void {
  setAttr(el, 'aria-keyshortcuts', aria);
  const base = title ?? el.getAttribute('title') ?? el.textContent?.trim() ?? '';
  const tail = ` (${keys})`;
  setAttr(el, 'title', base.endsWith(tail) ? base : `${base}${tail}`);
  let k = el.querySelector<HTMLElement>(':scope > kbd.kbd');
  if (!k) {
    k = h('kbd', { class: 'kbd', 'aria-hidden': 'true' });
    el.append(k);
  }
  setText(k, keys);
}
